<template>
  <div class="row page-content-full-width">
    <div class="col-12">
      <div class="row header justify-content-center no-gutters">
        <div class="col-12">
          <h2 v-if="isIIProject || isAVGProject || isGMVAProject" class="mb-2 mt-5">
            <img :src="logoUrl" class="ii-logo" />
          </h2>
          <h2 v-else class="mb-0 mt-5">Data Server</h2>
        </div>
      </div>
      <div class="row header justify-content-center no-gutters">
        <div class="col-12">
          <h4>{{ 'welcome' | i18n }}</h4>
        </div>
      </div>
      <div class="row form-container justify-content-center no-gutters">
        <div class="col col-xs-12 col-md-8 col-lg-6 col-xl-4 no-gutters">
          <b-form @submit="onSubmit">
            <b-form-group>
              <b-form-input
                id="username"
                v-model="formData.email"
                class="form-control"
                :placeholder="'Email or username' | i18n"
                size="sm"
              />
            </b-form-group>
            <b-form-group>
              <b-form-input
                id="password"
                v-model="formData.password"
                type="password"
                class="form-control"
                :placeholder="'password' | i18n"
                size="sm"
              />
            </b-form-group>
            <div v-b-modal.modal-1 class="forgot-link">{{ 'forgot_password' | i18n }}?</div>
            <b-button type="submit" variant="primary" class="btn-sign-in" :disabled="!isFormValid" size="sm" id="submit">
              {{ 'sign_in' | i18n }}
            </b-button>
          </b-form>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-1"
      :title="'forgot_password' | i18n"
      centered
      content-class="rounded-8"
      :ok-disabled="!formData.email"
      @ok="resetPasswordEmail"
    >
      <b-form-input v-model="formData.email" type="email" class="form-control" :placeholder="'email' | i18n" size="sm" />
    </b-modal>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import axios from 'axios';

import { AuthMixin, NavigationMixin, NotificationMixin, LicenseMixin, FirebaseMixinOne } from '../mixins';
import { SUPPORTED_LANGUAGES } from '../../../../constants';
import IIlogo from '../assets/ii-logo.gif';
import digital35Logo from '../assets/digital35.png';
import sensisLogo from '../assets/sensis-logo.svg';
import gmvaLogo from '../assets/gmva_logo.png';

export default {
  name: 'SignIn',
  mixins: [AuthMixin, NavigationMixin, NotificationMixin, LicenseMixin, FirebaseMixinOne],
  data: function () {
    return {
      formData: { email: null, password: null },
      isFormValid: false,
      baseURL: axios.defaults.baseURL,
      logoUrl: '',
    };
  },
  watch: {
    formData: {
      handler: function (value) {
        this.isFormValid = typeof value.email === 'string' && value.email !== '' && typeof value.password === 'string' && value.password !== '';
      },
      deep: true,
    },
  },
  async created() {
    if (this.isAuthenticated) {
      this.goToHome();
    }
    await this.renderIIlogo();
  },
  methods: {
    goToHome() {
      if (this.isAVGProject) {
        return this.$router.push({ name: 'home-avg' });
      }
      this.$router.push({ name: 'home' });
    },
    renderDefaultLogo() {
      console.log('this.isGMVAProject', this.isGMVAProject);
      if (this.isAVGProject || this.isEKAVProject) {
        return (this.logoUrl = sensisLogo);
      }
      if (this.isDIGITAL35Project) {
        return (this.logoUrl = digital35Logo);
      }
      if(this.isGMVAProject) {
        return (this.logoUrl = gmvaLogo);
      }
      this.logoUrl = IIlogo;
    },
    async renderIIlogo() {
      try {
        const url = `${this.baseURL}/api/v1/static/pdf-templates/companyLogo.png?dummy=${Math.random()}`;
        const data = await axios(url);
        if (!data) {
          return this.renderDefaultLogo();
        } else {
          if (data.includes('DOCTYPE')) {
            return this.renderDefaultLogo();
          }
          this.logoUrl = url;
        }
      } catch (error) {
        this.renderDefaultLogo();
      }
    },
    async onSubmit(evt) {
      evt.preventDefault();
      if (this.isFormValid) {
        try {
          const auth = await this.authService.signIn({
            email: this.formData.email,
            password: this.formData.password,
          });

          if (auth.firebase) {
            await this.firebaseServiceOne.signIn(auth.firebase.token, this.formData.email);
          }
          const decodedAuth = jwt.decode(auth.access_token);

          const localLanguage = localStorage.getItem('lng');

          const newLanguage = decodedAuth.language || (localLanguage ? JSON.parse(localLanguage).toUpperCase() : 'EN');

          this.setAuth({
            ...auth,
            role: decodedAuth.role,
            email: decodedAuth.email,
            username: decodedAuth.username,
            language: newLanguage,
          });

          if (SUPPORTED_LANGUAGES.includes(newLanguage.toLowerCase())) {
            console.log(newLanguage.toLowerCase(), 'newLanguage.toLowerCase()');
            this.$changeLanguage(newLanguage.toLowerCase());
          }

          if (this.$route.query.redirect_uri) {
            this.goTo(this.$route.query.redirect_uri);
          } else {
            this.goToHome();
          }
        } catch (err) {
          this.showNotification({
            type: 'error',
            title: this.$translate('sign_in'),
            message: err.message,
          });
        }
      }
    },
    async resetPasswordEmail() {
      if (this.formData.email) {
        try {
          const auth = await this.authService.restorePasswordEmail({
            email: this.formData.email,
          });
          this.showNotification({
            type: 'success',
            title: this.$translate('restore_password'),
            message: auth.data,
          });
        } catch (err) {
          this.showNotification({
            type: 'error',
            title: this.$translate('restore_password'),
            message: 'Incorrect data',
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  text-align: center;
}

.header {
  margin-top: 20px;

  h3 {
    margin-left: 0;
  }
}

.form-container {
  margin-top: 25px;
}

.btn {
  height: 40px;
  line-height: 24px;
  font-size: 1rem;

  &.btn-sign-in {
    width: 100%;
  }
}
.forgot-link {
  color: rgb(3, 102, 214);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  text-align: right;
  margin-top: -25px;
  margin-bottom: 20px;
}
.ii-logo {
  height: 75px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .modal-footer {
  justify-content: space-between;
  padding: 1.5rem;
  padding-top: 0;
  border: none;
  & > button {
    padding-right: 50px;
    padding-left: 50px;
    margin: 0;
  }
}
</style>
